<template>
 <AdminPanelMegogoService />
</template>

<script>
import AdminPanelMegogoService from '../components/AdminPanelMegogoService.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelMegogoService
    },
    methods: {},
    mounted() {}
}
</script>
